import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsUUID,
  IsOptional,
  IsBoolean,
  IsDateString,
  ValidateIf,
} from 'class-validator'
import { IsAfter, IsNotPast } from '../../../utils/date.validator'

export class CreateLearningPathTeachingAssignmentDto {
  @ApiProperty({ description: 'ID du parcours à assigner' })
  @IsUUID()
  learningPathId!: string

  @ApiProperty({ description: "ID de l'enseignement (Teaching)" , type: 'string'})
  @IsUUID()
  teachingId!: string

  @ApiPropertyOptional({ description: 'ID du sujet externe' })
  @IsOptional()
  @IsUUID()
  subjectExternalId?: string

  @ApiPropertyOptional({ description: 'ID du niveau de classe externe' })
  @IsOptional()
  @IsUUID()
  classLevelExternalId?: string

  @ApiPropertyOptional({ description: "ID de l'établissement" })
  @IsOptional()
  @IsUUID()
  establishmentId?: string

  @ApiPropertyOptional({ description: "ID de l'année scolaire" })
  @IsOptional()
  @IsUUID()
  schoolYearId?: string

  @ApiPropertyOptional({ description: 'Date de disponibilité' })
  @IsOptional()
  @IsDateString()
  @IsNotPast({
    message: 'La date de disponibilité ne peut pas être dans le passé',
  })
  availableFrom?: string

  @ApiPropertyOptional({ description: "Date d'échéance" })
  @IsOptional()
  @IsDateString()
  @IsNotPast({ message: 'La date limite ne peut pas être dans le passé' })
  @ValidateIf(o => o.availableFrom && o.dueAt)
  @IsAfter('availableFrom', {
    message: 'La date limite doit être après la date de disponibilité',
  })
  dueAt?: string

  @ApiPropertyOptional({ description: 'Visibilité du parcours' })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean
}
